// extracted by mini-css-extract-plugin
module.exports = {"root":"Page_root__22RuT","content":"Page_content__2WyKX","scrollingDisabled":"Page_scrollingDisabled__1Un0-"};